/**
 * Lembrete da ROTINA DE COBRANÇA, no canto do cockpit. [Bruno 2026-10-13]
 * "Um lembrete apenas para a Daniele": aparece só para quem é responsável pela
 * tarefa (o servidor filtra pelo e-mail de quem está logado), no dia dela e
 * enquanto não for marcada como feita. "Depois" esconde até o dia seguinte.
 */
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { financeiroApi } from '../services/api';
import { EMAILS_FINANCEIRO } from '../lib/menuSistema';

const INTERVALO_MS = 30 * 60 * 1000;
const hoje = () => new Date().toISOString().slice(0, 10);

function meuEmail() {
  try { return String((JSON.parse(localStorage.getItem('usuario') || 'null') || {}).email || '').toLowerCase(); } catch (_) { return ''; }
}

export default function LembreteFinanceiro() {
  if (!EMAILS_FINANCEIRO.includes(meuEmail())) return null;
  return <LembreteInterno />;
}

function LembreteInterno() {
  const navigate = useNavigate();
  const [dados, setDados] = useState(null);
  const [aberto, setAberto] = useState(false);
  const [escondido, setEscondido] = useState(() => {
    try { return localStorage.getItem('fin_lembrete_depois') === hoje(); } catch (_) { return false; }
  });
  const carregar = useCallback(() => {
    financeiroApi.lembretes().then(({ data }) => setDados(data)).catch(() => setDados(null));
  }, []);
  useEffect(() => {
    carregar();
    const t = setInterval(carregar, INTERVALO_MS);
    const mudou = () => carregar();
    window.addEventListener('fin-lembretes-mudou', mudou);
    return () => { clearInterval(t); window.removeEventListener('fin-lembretes-mudou', mudou); };
  }, [carregar]);

  if (!dados || !dados.itens.length || escondido) return null;
  const marcar = async (t) => {
    setDados((d) => ({ ...d, itens: d.itens.filter((x) => x.id !== t.id) }));
    try { await financeiroApi.marcarTarefa(t.id, dados.competencia, true); } catch (_) { carregar(); }
  };
  const depois = () => {
    try { localStorage.setItem('fin_lembrete_depois', hoje()); } catch (_) { /* ok */ }
    setEscondido(true);
  };
  const n = dados.itens.length;
  return (
    <div className="fin-lembrete" role="region" aria-label="Lembretes de cobrança" style={{
      position: 'fixed', left: 18, bottom: 18, zIndex: 2300, width: 380, maxWidth: 'calc(100vw - 36px)',
      background: 'var(--paper, #fff)', color: 'var(--ink, #15171C)', border: '1px solid var(--rule, #d9dee8)',
      borderLeft: '5px solid #9a6400', borderRadius: 12, boxShadow: '0 10px 30px rgba(0,0,0,0.18)', padding: '12px 14px',
    }}>
      <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: '.05em', textTransform: 'uppercase', color: '#9a6400' }}>Rotina de cobrança</div>
      <div style={{ fontWeight: 700, fontSize: 14.5, margin: '3px 0 6px' }}>
        {dados.de_hoje ? `${dados.de_hoje} tarefa(s) para hoje` : ''}{dados.de_hoje && dados.atrasadas ? ' · ' : ''}{dados.atrasadas ? `${dados.atrasadas} atrasada(s)` : ''}
      </div>
      {(aberto ? dados.itens : dados.itens.slice(0, 4)).map((t) => (
        <label key={t.id} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 13, padding: '4px 0', cursor: 'pointer' }}>
          <input type="checkbox" onChange={() => marcar(t)} style={{ marginTop: 2 }} aria-label={`Feito: ${t.cliente}`} />
          <span style={{ minWidth: 0 }}>
            <b>{t.cliente}</b> — {t.acao}
            <span style={{ display: 'block', fontSize: 12, color: 'var(--ink-soft, #666)', overflowWrap: 'anywhere' }}>
              {t.canal_rotulo}{t.destino ? ` · ${t.destino}` : ''}{t.data < dados.hoje ? ` · era ${t.data.slice(8, 10)}/${t.data.slice(5, 7)}` : ''}
            </span>
          </span>
        </label>
      ))}
      {n > 4 && !aberto && <button type="button" className="btn btn-link btn-sm" onClick={() => setAberto(true)} style={{ padding: 0 }}>ver mais {n - 4}</button>}
      <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
        <button type="button" className="btn btn-primary btn-sm" onClick={() => navigate('/escritorio/financeiro?view=rotina')}>Abrir a rotina</button>
        <button type="button" className="btn btn-outline btn-sm" onClick={depois}>Depois</button>
      </div>
    </div>
  );
}
